import React, { useRef, useEffect } from 'react';
import { animate } from 'animejs';
import { getWhatsAppUrl } from '../utils/links';
import { useLanguage } from '../context/LanguageContext';
import './CTAFinal.css';

function CTAFinal() {
  const { lang, t } = useLanguage();
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        const block = section.querySelector('.cta-final-block');
        const btn = section.querySelector('.cta-final-btn');
        if (block) animate(block, { opacity: [0, 1], y: [20, 0], duration: 550, ease: 'outExpo' });
        if (btn) animate(btn, { opacity: [0, 1], y: [12, 0], duration: 500, delay: 200, ease: 'outExpo' });
        observer.disconnect();
      },
      { rootMargin: '0px 0px -80px 0px', threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className="cta-final">
      <div className="cta-final-block">
        <h2 id="cta-final-title" className="cta-final-title">
          {t('ctaFinal.title')}
        </h2>
        <p className="cta-final-subtitle">
          {t('ctaFinal.subtitle')}
        </p>
      </div>
      <a
        href={getWhatsAppUrl(lang)}
        className="cta-final-btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t('ctaFinal.ariaLabel')}
      >
        {t('ctaFinal.btn')}
      </a>
    </div>
  );
}

export default CTAFinal;
